import React from 'react'
import HeroCarousel from './HomeCarousel/HeroCarousel'
import AboutUsSection from './About/AboutUsSection'
import OurServices from './OurService/OurServices'
import ServiceableCities from './ServiceableCities/ServiceableCities'
import WeWorkWith from './WeWorkWith/WeWorkWith'
import Enquiry from './Enquiry/Enquiry'

function Home() {
  return (
    <>
        <HeroCarousel />
        <AboutUsSection />
        <OurServices />
        <ServiceableCities />
        <WeWorkWith />
        <Enquiry />
    </>
  )
}

export default Home